import React from 'react'
import Layout from '../components/Layout'
import AreaMacedoniaBanner from '../components/AreaMacedonia/AreaMacedoniaBanner'
import EducationIndicators from '../components/AreaMacedonia/EducationIndicators'

function AreaMacedonia() {
  return (
    <Layout>
        <AreaMacedoniaBanner />
        <EducationIndicators />
    </Layout>
  )
}

export default AreaMacedonia